import { SYSConfig, html } from "../../../../"
import { FieldValidationTextGet } from "../../../../../ovlsyscomponents/sysdefaulthtmlsnippets01"
import {
  HookFieldValidationTextDisplay,
  HookFieldValidationTextDisplay_ReturnType,
} from "../../../../global/hooks"
import { _RenderTracking } from "../../../../tracker/tracker"

import { SYSBaseElement } from "../../../sysbaseelement"
import type { SYSField } from "../../actions"

export class SYSValidationHint extends SYSBaseElement {
  field: SYSField
  props: any
  hookFieldValidationText: any
  async init() {
    this.field = this.props()
    this.hookFieldValidationText =
      this.actions.app.global.hooks?.[
        HookFieldValidationTextDisplay.replace(
          "{subFeature}",
          this.state.ovl.forms[this.field.formType][this.field.formId]
            .subFeature
        )
      ]
    await super.init()
  }
  async getUI() {
    let field = this.field
    // access visible is important if the underlying field got changed
    // usecase KaltAG LieferungWerkadresse -> Change to PLZ, -> Plz gets showed and has error. But when left this control doesn't show a hint
    // and accessing .visible fixes that
    // -> needs revisit after current tracking changes (05.24), maybe not necessary anymore

    field._state.visible
    let res
    let hasAlways
    let visibleErrors = field.validationResult.System.concat(
      field.validationResult.Validate
    )
      .concat(field.validationResult.ValueChanged)
      .filter((f) => {
        let isAlways = f.displayType === "Always"
        if (isAlways) {
          hasAlways = true
        }
        return isAlways || (f.displayType === "WhenTouched" && field.watched)
      })
    let hookRes: HookFieldValidationTextDisplay_ReturnType
    if (this.hookFieldValidationText) {
      let formState = this.state.ovl.forms[field.formType][field.formId]
      hookRes = this.hookFieldValidationText({
        field,
        formState,
        visibleErrors,
      })
    }
    if (hookRes === undefined) {
      res = FieldValidationTextGet(field, visibleErrors).res
    } else {
      res = hookRes.res
    }
    let hideclass = ""
    if (
      (field.hasFocus &&
        !hasAlways &&
        !SYSConfig.formDefaults.showErrorWhileTyping) ||
      field.inactive ||
      res.length === 0
    ) {
      hideclass = "ovl-hideControl"
    }
    return html`
      <div
        class=${`fd-form-message fd-form-message--error ovl-formcontrol-validation ovl-formcontrol-validation__${field.fieldKey} ${hideclass}`}
      >
        ${res}
      </div>
    `
  }
}
